import { useOutletContext } from "react-router-dom";
import { PageHeader } from "@/components/site/PageHeader";
import { Manifesto } from "@/components/home/Manifesto";
import { StatsStrip } from "@/components/home/StatsStrip";
import { TestDriveCTA } from "@/components/home/TestDriveCTA";
import { Reveal, Stagger, Item } from "@/components/motion/Reveal";

const FACTS = [
  { k: "Feb 2025", v: "JETOUR launches in Pakistan with the Dashing and X70 Plus." },
  { k: "25+", v: "Authorized dealerships across Pakistan, from Peshawar to Karachi." },
  { k: "2026", v: "The T-Series arrives: T1, T2 and their i-DM plug-in hybrids." },
  { k: "3S", v: "West Canal Motors: sales, service and spare parts on one site in Faisalabad." },
];

export default function About() {
  const { settings, vehicles } = useOutletContext();
  return (
    <div data-testid="about-page">
      <PageHeader eyebrow="About West Canal Motors" lines={["Sold here. Serviced here.", "Supplied here."]} sub={settings.tagline} />

      <section className="wrap grid gap-14 pb-24 lg:grid-cols-12 sm:pb-32">
        <Reveal className="lg:col-span-5" y={40}>
          <div className="clip-frame group relative aspect-[4/5] overflow-hidden border border-white/10">
            <img src="/showroom.jpg" alt="Showroom" className="h-full w-full object-cover grayscale-[30%] transition-[transform,filter] duration-[1200ms] group-hover:scale-105 group-hover:grayscale-0" />
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/80 to-transparent" />
            <p className="absolute bottom-5 left-5 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300">West Canal Road · Faisalabad</p>
          </div>
        </Reveal>
        <div className="lg:col-span-7 lg:pl-8">
          <Reveal y={12}><p className="eyebrow">Who we are</p></Reveal>
          <Reveal delay={0.1}><h2 className="display-md mt-5 font-display" data-testid="about-title">{settings.about_title}</h2></Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 font-editorial text-xl italic leading-relaxed text-gold sm:text-2xl">{settings.about_text?.split(". ")[0]}.</p>
            <p className="mt-6 text-base leading-relaxed text-slate-400" data-testid="about-text">{settings.about_text?.split(". ").slice(1).join(". ")}</p>
          </Reveal>
          <Reveal delay={0.3} className="mt-12"><p className="eyebrow mb-6">JETOUR in Pakistan</p></Reveal>
          <Stagger className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2" gap={0.08}>
            {FACTS.map((f) => (
              <Item key={f.k} className="bg-obsidian p-6">
                <p className="font-display text-3xl font-extrabold tracking-tight">{f.k}</p>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{f.v}</p>
              </Item>
            ))}
          </Stagger>
        </div>
      </section>

      <StatsStrip stats={settings.stats} />
      <Manifesto settings={settings} compact />
      <TestDriveCTA vehicle={vehicles[2] || vehicles[0]} />
    </div>
  );
}
